export default __webpack_public_path__ + "static/media/icon-mitigation-grey.abf4f0b1.svg";